// extracted by mini-css-extract-plugin
export default {"header":"MerchantList_header__zlDi5","merchant_list":"MerchantList_merchant_list__JeomP","title":"MerchantList_title__WV2TI","search":"MerchantList_search__aqfV7"};